import { render } from "./Contact_index_en_m.vue?vue&type=template&id=31006df5&scoped=true"
import script from "./Contact_index_en_m.vue?vue&type=script&lang=js"
export * from "./Contact_index_en_m.vue?vue&type=script&lang=js"

import "./Contact_index_en_m.vue?vue&type=style&index=0&id=31006df5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31006df5"

export default script